import Modal from "../../common/ui/modal";

const DeleteTheme = ({theme, removeTheme}) => {

    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Theme"
                content={[{
                    text: `Are you sure you wish to delete the below theme?`,
                    classes: ""
                }, {
                    text: `${theme?.text}`,
                    classes: "text-blue font-bold"
                }]}
                confirmButtonLabel="Confirm Delete"
                handleConfirm={() => {
                    removeTheme(theme);
                }}
                showIcon={false}
            />
        </>
    )
}

export default DeleteTheme
